import useFetch from "use-http";

export const useCreateNewApp = () => {
  const create = useFetch("/auth/api/apps").post;
  const validate = useFetch("/auth/api/apps/validate").post;

  return { create, validate };
};
